import { useCallback, useState } from 'react';

import {
  useGetNotificationSettingsQuery,
  useGetUnreadCountQuery,
} from '@app/api/Notifications';
import { useUserPrint } from '@app/hooks';
import { useErrorHandler } from '@app/shared/hooks';

const UNREAD_COUNT_POLLING_INTERVAL = 60000;

export const useNotificationsBell = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { activeBranchId } = useUserPrint();

  // «Дёргаем при авторизации»: колокольчик монтируется в PageProvider сразу
  // после входа в приложение. Настройки уведомлений подтягиваются один раз,
  // дальше RTK Query отдаёт их из кеша окну «Уведомления»
  // (usePopupNotificationsSetting).
  useGetNotificationSettingsQuery(
    { ActiveBranchId: activeBranchId },
    { skip: !activeBranchId }
  );

  const { data, error, isError } = useGetUnreadCountQuery(
    { ActiveBranchId: activeBranchId },
    {
      pollingInterval: UNREAD_COUNT_POLLING_INTERVAL,
      skip: !activeBranchId,
    }
  );

  useErrorHandler([{ flag: isError, error }]);

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  return {
    unreadCount: data ?? 0,
    isModalOpen,
    openModal,
    closeModal,
  };
};
